
import { defineComponent } from "vue";import TalentList from "./ReverseTokyoTalentList.vue";
import Usecase from "@/components/common_presentational/Usecase.vue";

export default defineComponent({
  name: "StemScreen",
  components: {
    TalentList,
    Usecase
  },
});
